import { PaginatedSearchBaseOptionsResult } from '../../../../../store/base';
import RouterUtilities from '../../../../../helpers/RouterUtilities';

export default class TenantsRequestViewModel extends PaginatedSearchBaseOptionsResult {
  keyword: string;
  period: string;
  startDate: string;
  endDate: string;
  public parse(location: Location) {
    const obj = RouterUtilities.locationSearchStringParse(location);
    if (!obj) {
      return;
    }

    super.baseParse(obj);
    if ('keyword' in obj && typeof obj.keyword === 'string') {
      this.keyword = obj.keyword;
    }
  }
}
